import { RecordTypeBase } from './base/record-type-base';

export class RecordType extends RecordTypeBase { }